/* eslint-disable max-len */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-unused-state */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */

import React, { Fragment } from 'react';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { connect } from 'react-redux';
import jsPDF from 'jspdf'; // eslint-disable-line import/no-named-as-default

import LOGO_BARKERS from 'assets/images/basket/Barkers-logo.png';
import step1 from 'assets/images/basket/basket-step-1.svg';
import step2 from 'assets/images/basket/basket-step-2.svg';
import step3 from 'assets/images/basket/basket-step-3.svg';
import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import ExternalLink from 'components/generic/ExternalLink.component';
import Icon from 'components/generic/Icon.component';
import CurrencySign from 'components/price/CurrencySign.component';
import S from 'constants/string.const';
import {
  selectCurrentSalonIsBarkers,
  selectCurrentSalonIsLoreal,
  selectCurrentSalonName,
} from 'selectors/currentSalon.selectors';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import { exportCSV } from 'utils/converters/csv.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import { formatDayToYear } from 'utils/date/format.util';
import { nowAsTimestamp } from 'utils/date/now.util';
import logger from 'utils/logger.util';
import createNodeKey from 'utils/react/createNodeKey.util';
import fixed from 'utils/values/fixed.util';
import parsfixed from 'utils/values/parsfixed.util';

import SimpleDialog from 'scheduler/components/SimpleDialog';
import { BasketItem } from 'stocks/components/common/BasketItem';
import { imgData } from 'stocks/components/common/utils/imgPdf';

import 'jspdf-autotable';

import CN from './TableStocksOrdering.module.scss';

const CTAG = 'TableStocksOrdering';
const L = logger(CTAG);

const USE_LOREAL = false;

const LINK_ROADMAP = 'https://barkershairdressing.com/';
const LINK_MAIL = 'mailto:sales@barkershairdressing.com';

const TODAY = fromAnyToTrimmed(formatDayToYear(nowAsTimestamp()));

class TableStocksOrdering extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deleteProductModal: false,
      orderModal: false,
      toggleBasket: true,
      emptyBasketModal: false,
      lastOrderModal: false,
      email: 'mbliok@melontech.com', // '',  EMAIL send
      printModal: false,
      deleteBasketItem: null,
      modalCSVinfo: true,
      barkersModal: false,
    };
  }

  componentDidMount() {
    this.getWindowScrollTop();
  }

  onClose = () => void this.setState({ deleteProductModal: false, emptyBasketModal: false, lastOrderModal: false });
  onDelete = () => void this.setState({});
  onDeleteProductModal = (itemDelete) => void this.setState({ deleteBasketItem: itemDelete });

  onDeleteOrderItem = () => {
    if (this.state.deleteBasketItem) {
      this.props.deleteOrderItem(this.state.deleteBasketItem);
      this.setState({ deleteBasketItem: null });
    }
  };
  onIncrement = (editItem) => {
    const item = editItem;
    item.quantity = editItem.quantity + 1;
    this.props.editOrderItem(item);
  };

  onDecrement = (editItem) => {
    const item = editItem;
    let value = editItem.quantity - 1;
    if (value < 1) {
      value = 1;
    }
    item.quantity = value;
    this.props.editOrderItem(item);
  };

  onEmptyBasketModal = () => {
    if (this.props.emptyBasket) {
      this.setState({ emptyBasketModal: true });
    }
  };

  onEmptyBasketClick = () => {
    this.props.emptyOrderBasket(this.props.salonId);
    this.setState({ emptyBasketModal: false });
  };

  onLoadLastOrder = () => {
    this.props.getLastOrderData(this.props.salonId, true);
    this.setState({ lastOrderModal: false });
  };

  getWindowScrollTop = () => {
    // TODO: remove this method, inline the code, it is used only once, same with the other 2 named the same
    if (window.pageYOffset) {
      return window.pageYOffset;
    } else if (document.documentElement) {
      return document.documentElement.scrollTop;
    }
    return 0;
  };

  showOrderModal = () => {
    this.setState({ orderModal: true });
    this.props.generateOrderData();
  };

  loadLastOrderModal = () => void this.setState({ lastOrderModal: true });
  closeOrderModal = () => void this.setState({ orderModal: false, barkersModal: false });
  toggleBasket = () => void this.setState({ toggleBasket: !this.state.toggleBasket });

  searchFunc = (el) =>
    el
      .getName()
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .replace(/’/, '')
      .replace(/'/, '')
      .toLocaleString('en-GB')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[\u00E9]/g, '')
      .search(this.props.search) !== -1 ||
    el
      .getBrand()
      .trim()
      .normalize('NFD')
      .replace(/^0+'/, '')
      .replace(/’/, '')
      .replace(/'/, '')
      .toLocaleString('en-GB')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.props.search) !== -1 ||
    el
      .getFamily()
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .toLocaleString('en-GB')
      .replace(/’/, '')
      .replace(/'/, '')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.props.search) !== -1 ||
    el
      .getCategory()
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .toLocaleString('en-GB')
      .replace(/’/, '')
      .replace(/'/, '')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.props.search) !== -1 ||
    (el.barcode ? el.barcode.toString() : '')
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .replace(/’/, '')
      .replace(/'/, '')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.props.search) !== -1;

  sendReceiptToEmail = () => {};
  generateCSV = ({ showModal }) => {
    const { csvData } = this.props;
    L.warn('generateCSV()', 'csvData:', csvData);

    // images with state - not working on some iPad
    const CSVinfo = document.querySelector('.dialog-container.no-show.csv-info-modal');
    if (CSVinfo && fromAnyToBool(showModal)) {
      CSVinfo.style.display = 'inline-flex';
    }

    const normalizedCsvData = csvData.map((item) => ({
      Barcode: item.barcode ?? '',
      Brand: item.brand ?? '',
      'Sub brand': item.sub_brand ?? '',
      'Product name': item.title ?? '',
      Quantity: item.quantity,
    }));

    exportCSV({ data: normalizedCsvData, fileName: `Slick-Stock-Order-${TODAY}.csv` });

    this.setState({ orderModal: false });
  };
  modalDisplayHidden = () => {
    const CSVinfo = document.querySelector('.dialog-container.no-show.csv-info-modal');
    if (CSVinfo) {
      CSVinfo.style.display = 'none';
    }
  };
  // JSpdf Generator For generating the PDF
  jsPdfGenerator = () => {
    // eslint-disable-next-line new-cap
    const doc = new jsPDF('p', 'pt');
    const res = doc.autoTableHtmlToJson(document.getElementById('table'));
    const { height } = doc.internal.pageSize;

    doc.addImage(imgData, 'PNG', 426, 35, 115, 68); // x, y, width and height

    doc.setFontSize(12);
    doc.setTextColor('#192340'); // dark blue
    doc.text('Order generated by:', 45, 50); // x, y

    doc.setTextColor(93, 102, 127); // gray text
    doc.text(`${this.props.salonName}`, 160, 50);

    doc.setTextColor('#192340');
    doc.text('Date:', 45, 74);

    doc.setTextColor(93, 102, 127);
    doc.setFontSize(11);
    doc.text(`${TODAY}`, 78, 74);

    doc.setFontSize(12);
    doc.setTextColor('#192340');
    doc.text('Unique order reference:', 45, 100);

    doc.setTextColor(93, 102, 127);
    doc.setFont('courier');
    doc.setFontSize(13);
    doc.text(`${this.props.geratedOrderNumber ? this.props.geratedOrderNumber : '00000000001'}`, 175, 100);

    doc.autoTable(res.columns, res.data, {
      startY: 130, //  startY: height, => start on new page
      theme: 'grid', // 'striped', 'grid' or 'plain
      font: 'helvetica', // helvetica, times, courier
      lineWidth: 0.5, // tbl border width
      fontStyle: 'normal', // normal, bold, italic, bolditalic
      headerStyles: {
        cellPadding: 6,
        fontSize: 11.5, // px
        fillColor: '#F8EAFF', // brg pink
        textColor: '#192340', // dark blue
        lineColor: '#5D667F', // border
        lineWidth: 0.7, // tbl border width
      },
      styles: {
        cellPadding: 6,
        textColor: [93, 102, 127],
        fillColor: 255, // tbl background
        lineColor: '#5D667F', // tbl border color
      },

      halign: 'left', // left, center, right
      valign: 'middle', // top, middle, bottom
      fillStyle: 'F', // 'S', 'F' or 'DF' (stroke, fill or fill then stroke)
      columnWidth: 'auto', // 'auto', 'wrap' or a number
      afterPageContent(data) {
        doc.setFontSize(10);
        doc.text(' ', 45, height - data.settings.margin.bottom - 10);
      },
    });
    //  doc.autoTable(res.columns, res.data, {
    //    startY: doc.autoTableEndPosY() + 50,
    //  });

    doc.save(`${this.props.salonName} - ${TODAY} .pdf`);
  };
  showBarkersModal = () => {
    this.setState({ barkersModal: true, orderModal: false });
  };

  render() {
    const { salonName, isLorealSalon, isBarkersSalon } = this.props;
    const brandKeys = Object.keys(this.props.data).sort((s1, s2) => s1.localeCompare(s2));
    const orderKeys = Object.keys(this.props.orderItems).sort((s1, s2) => s1.localeCompare(s2));

    return (
      <div>
        <div className="stock-holding-nav">
          <table className="tbl-stock-fixed-header">
            <tbody>
              <tr>
                <td className="cbox" style={{ width: '40px' }}>
                  <div className="checkbox-box-custom-wrap">
                    <input
                      type="checkbox"
                      className="checkbox-box-custom"
                      id="cbAll"
                      checked={this.props.allItemsSelected}
                      onChange={this.props.toogleCheckAll}
                    />
                    <label className="checkbox-box-label" htmlFor="cbAll">
                      <div className="checkbox-box-custom-icon">
                        <span className="ic-sml-18px ic_check_white_18" />
                      </div>
                    </label>
                  </div>
                </td>
                <td className="product-name">
                  <span
                    role="button"
                    tabIndex={0}
                    onClick={() => {
                      this.props.onAddSort('title');
                    }}
                  >
                    Product name
                    {/* <img src={sortIcon} alt="Sort by product" /> */}
                  </span>
                </td>
                <td>
                  <span role="button" tabIndex={0} onClick={() => {}}>
                    <span>Quantity in stock </span>
                  </span>
                </td>
                <td>
                  <span role="button" tabIndex={0} onClick={() => {}}>
                    <span>Min Holding</span>
                  </span>
                </td>
                <td>
                  <span role="button" tabIndex={0} onClick={() => {}}>
                    <span>Max Holding</span>
                  </span>
                </td>
                <td>
                  <span role="button" tabIndex={0} onClick={() => {}}>
                    <span>Used/Sold last 30d</span>
                  </span>
                </td>
                <td className="pink-bgr">
                  <span role="button" tabIndex={0} onClick={() => {}}>
                    Suggested order
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="tbl-container move-down">
          <table className="table-stocks-body">
            <thead>
              <tr>
                <th style={{ width: '40px' }} />
                <th />
                <th />
                <th />
                <th />
                <th />
                <th />
              </tr>
            </thead>
            <tbody>
              {brandKeys.map((key) => {
                const brand = this.props.data[key];
                const subCategoryKeys = Object.keys(brand).sort((s1, s2) => s1.localeCompare(s2));
                return subCategoryKeys.map((catKey) => {
                  const subCategory = brand[catKey];
                  const categoryArr = Object.values(subCategory);
                  const stockList = [];
                  for (let i = 0; i < categoryArr.length; i += 1) {
                    stockList.push(...categoryArr[i]);
                  }
                  let stocks = stockList.filter(this.searchFunc).sort((s1, s2) => s1.title.localeCompare(s2.title));
                  if (this.props.lowInStock) {
                    stocks = stocks.filter((c) =>
                      c.units_in_stock || c.max_in_stock ? c.max_in_stock - c.units_in_stock > 0 : false,
                    );
                  } else {
                    stocks = stockList.filter(this.searchFunc).sort((s1, s2) => s1.title.localeCompare(s2.title));
                  }
                  if (!stocks.length) {
                    return <tr />;
                  }
                  return (
                    <Fragment key={`${key}-${catKey}`}>
                      <tr>
                        <td style={{ width: '40px', backgroundColor: '#630396' }} />
                        <td colSpan="3" className="brand-family-banner">
                          <div>
                            {key} - {catKey}
                          </div>
                        </td>
                        <td className="beta" />
                        <td className="beta" />
                        <td className="beta" />
                      </tr>
                      {stocks.map((stock) => {
                        let suggestedOrder = '-';
                        if (stock.max_in_stock) {
                          const averageOrder = stock.max_in_stock - stock.units_in_stock;
                          if (averageOrder < 0) {
                            suggestedOrder = '0';
                          } else {
                            suggestedOrder = averageOrder.toFixed();
                          }
                        }
                        return (
                          <tr key={stock.id}>
                            <td className="cbox" style={{ width: '40px' }}>
                              {stock.isInBasket && <span id="added-to-basket-icon" />}
                              {!stock.isInBasket && (
                                <div className="checkbox-box-custom-wrap">
                                  <input
                                    type="checkbox"
                                    className="checkbox-box-custom"
                                    id={`stocks-check-${stock.id}`}
                                    checked={stock.selected}
                                    onChange={() => {
                                      this.props.toggleOrderItem(stock, !stock.selected);
                                    }}
                                  />
                                  <label className="checkbox-box-label" htmlFor={`stocks-check-${stock.id}`}>
                                    <div className="checkbox-box-custom-icon">
                                      <span className="ic-sml-18px ic_check_white_18" />
                                    </div>
                                  </label>
                                </div>
                              )}
                            </td>
                            <td
                              role="button"
                              tabIndex={0}
                              className="product-name text-upper"
                              //   onClick={() => {
                              //   this.props.OnClickRow(stock);
                              // }}
                            >
                              {stock.title}
                            </td>
                            <td>{parsfixed(stock.units_in_stock)}</td>
                            <td>{stock.min_in_stock ? stock.min_in_stock : '-'}</td>
                            <td>{stock.max_in_stock ? stock.max_in_stock : '-'}</td>
                            <td>{fixed(parseFloat(stock.sold_last_30_days) + parseFloat(stock.used_last_30_days))}</td>
                            <td className="pink-bgr">{suggestedOrder}</td>
                          </tr>
                        );
                      })}
                    </Fragment>
                  );
                });
              })}
              {this.props.data.length === 0 && (
                <tr>
                  <td style={{ textAlign: 'center' }}>No products to show.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {/* BASKET */}
        <div className={this.state.toggleBasket ? 'basket-sidebar' : 'basket-sidebar mobile'}>
          <div>
            <div className="basket-header">
              <div>
                <span>Products</span>
                <span>{this.props.orderItemsCount}</span>
              </div>
              <div className="basket-icon" role="button" tabIndex={0} onClick={this.toggleBasket} />
              <div>
                <span>Cost (est)</span>
                <span>
                  <CurrencySign value={this.props.totalOrderItemsCost} />
                </span>
              </div>
            </div>
            <div className="basket-content">
              {!this.props.emptyBasket && (
                <div className="empty">
                  <p>Select products by clicking the tickbox on the left of the Brand name</p>
                  <p>Then click add to basket</p>
                </div>
              )}
              {this.props.emptyBasket && (
                <div className="basket-products">
                  {orderKeys.map((key) => {
                    const orderBrand = this.props.orderItems[key];
                    const subBrandKeys = Object.keys(orderBrand).sort((s1, s2) => s1.localeCompare(s2));
                    return (
                      <div>
                        <div className="basket-brand-banner">{key}</div>
                        {subBrandKeys.map((subKey) => {
                          const subCategory = orderBrand[subKey];

                          const stockListObj = Object.values(subCategory).map((e) => [...e]);
                          const stockListArr = Object.values(stockListObj);
                          const stockList = [];
                          for (let i = 0; i < stockListArr.length; i += 1) {
                            if (stockListArr[i]) {
                              stockList.push(...stockListArr[i]);
                            }
                          }
                          const items = stockList;
                          return (
                            <div>
                              <div className="tbl-products-container">
                                <table className="tbl-products">
                                  {items.map((product, index) => (
                                    <tr
                                      className="header-sub-brand"
                                      key={createNodeKey({ index, tag: product.sub_brand })}
                                    >
                                      <th className="cell-name">{product.sub_brand}</th>
                                      <th className="cell-q">Quantity</th>
                                      <th className="cell-price">Price</th>
                                      <th className="cell-total">Subtotal</th>
                                      <th className="cell-del" />
                                    </tr>
                                  ))}

                                  {items.map((product) => (
                                    <BasketItem
                                      orderItem={product}
                                      onDelete={this.onDeleteProductModal}
                                      onIncrement={this.onIncrement}
                                      onDecrement={this.onDecrement}
                                    />
                                  ))}
                                </table>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                  <div style={{ backgroundColor: 'gray' }} />
                </div>
              )}
            </div>
            <div className="basket-footer">
              <div className="flex-btns">
                <button className="btn btn-violet" onClick={this.props.saveBasket}>
                  {this.props.basketSaved ? 'BASKET SAVED!' : 'SAVE BASKET'}
                </button>
                <button className="btn btn-outline" onClick={this.onEmptyBasketModal}>
                  EMPTY BASKET
                </button>
              </div>
              <div className="flex-btns">
                <button
                  className="btn btn-blue"
                  onClick={this.showOrderModal}
                  disabled={this.props.orderItemsCount === 0}
                >
                  GENERATE ORDER
                </button>
                <button className="btn btn-outline blue" onClick={this.loadLastOrderModal}>
                  LOAD LAST ORDER
                </button>
              </div>
            </div>
          </div>
          {/* BASKET END */}
          {this.state.deleteBasketItem && (
            <SimpleDialog
              title=" "
              leftButtonText="Cancel"
              rightButtonText="YES"
              onLeft={() => {
                this.setState({ deleteBasketItem: null });
              }}
              onRight={this.onDeleteOrderItem}
              displayHeader="header-non"
              uniqueClass="wide-btn"
              isOpen={this.state.deleteBasketItem}
            >
              <div className="dialog-inner-title">Remove product from basket</div>
              <div className="dialog-text" style={{ padding: '12px', lineHeight: '22px' }}>
                Are you sure you want to remove {this.state.deleteBasketItem.title} from your basket?
              </div>
            </SimpleDialog>
          )}
          {this.state.emptyBasketModal && this.props.emptyBasket && (
            <SimpleDialog
              title=" "
              leftButtonText="Cancel"
              rightButtonText="YES, REMOVE"
              onLeft={this.onClose}
              onRight={this.onEmptyBasketClick}
              displayHeader="header-non"
              uniqueClass="wide-btn"
              isOpen={this.state.emptyBasketModal}
            >
              <div className="dialog-inner-title">Empty basket</div>
              <div className="dialog-text" style={{ padding: '12px', lineHeight: '22px' }}>
                Are you sure you want to empty your basket?
              </div>
            </SimpleDialog>
          )}
          {this.state.lastOrderModal && (
            <SimpleDialog
              title=" "
              leftButtonText="Cancel"
              rightButtonText="Load"
              onLeft={this.onClose}
              onRight={this.onLoadLastOrder}
              displayHeader="header-non"
              uniqueClass="wide-btn"
              isOpen={this.state.lastOrderModal}
            >
              <div className="dialog-inner-title">Last order</div>
              <div className="dialog-text" style={{ padding: '12px', lineHeight: '22px' }}>
                Choose your order method
              </div>
            </SimpleDialog>
          )}

          {fromAnyToBool(this.state.orderModal) && (
            <SalonModal tag="StockOrderModal" isOpen={this.state.orderModal} variant="medium">
              <SalonModal.Header>
                Generate Order
                <Button variant="empty" onClick={this.closeOrderModal}>
                  <Icon variant="close" />
                </Button>
              </SalonModal.Header>
              <SalonModal.Body>
                <div className={CN.modalContainer}>
                  <div className={CN.modalSubtitle}>Choose your method of ordering:</div>
                  <div className={CN.modalButtons}>
                    <button className={CN.buttonExcel} onClick={() => this.generateCSV({ showModal: false })}>
                      Download Spreadsheet
                    </button>
                    <button className={CN.buttonPdf} onClick={this.jsPdfGenerator}>
                      Generate Pdf
                    </button>
                  </div>

                  <div className={CN.logoContainer}>
                    {isBarkersSalon && <button onClick={this.showBarkersModal} className={CN.logoBarkers} />}
                    {(isLorealSalon || USE_LOREAL) && (
                      <button onClick={() => this.generateCSV({ showModal: true })} className={CN.logoLoreal} />
                    )}
                  </div>
                </div>
              </SalonModal.Body>
            </SalonModal>
          )}

          {fromAnyToBool(this.state.barkersModal) && (
            <SalonModal tag="StockOrderModal" isOpen={this.state.barkersModal} variant="medium">
              <SalonModal.Header>
                Order Directly with Barkers
                <Button variant="empty" onClick={this.closeOrderModal}>
                  <Icon variant="close" />
                </Button>
              </SalonModal.Header>
              <SalonModal.Body>
                <div className={CN.modalContainer}>
                  <img src={LOGO_BARKERS} className={CN.logo} alt="Barkers" />
                  <div className={CN.modalText}>
                    <p>
                      <ExternalLink link={LINK_ROADMAP} variant="inline">
                        <span className={CN.link}>Click here {S.space}</span>
                      </ExternalLink>
                      to login to your Barkers Account.
                    </p>
                    <p>You will be able to choose the products required and order online quickly and securely.</p>
                    <p>
                      Alternatively you can send your CSV or PDF order directly to the Sales Team at Barkers via this
                      email address:
                      <ExternalLink link={LINK_MAIL} variant="inline">
                        <span className={CN.mail}>sales@barkershairdressing.com</span>
                      </ExternalLink>
                    </p>
                  </div>

                  <div className={CN.modalButtons}>
                    <ReactHTMLTableToExcel
                      className={CN.buttonExcel}
                      table="table-to-excel"
                      filename={`${salonName} - Stock-Order-${TODAY}`}
                      sheet="tablexls"
                      buttonText="Export to Excel"
                    />
                    <button className={CN.buttonPdf} onClick={this.jsPdfGenerator}>
                      Generate Pdf
                    </button>
                  </div>
                </div>
              </SalonModal.Body>
            </SalonModal>
          )}
          <SimpleDialog
            title="Now let’s upload your order to the L’Oréal Online Shop!"
            leftButtonText=""
            rightButtonText=""
            onCancel={this.modalDisplayHidden}
            onLeft={() => {}}
            onRight={() => {}}
            // displayHeader="header-non"
            uniqueClass="csv-info-modal"
            isOpen={this.state.modalCSVinfo}
          >
            <div className="top-text">
              <a href="https://www.lorealpartnershop.com/uk/en/login/" target="_blank" rel="noopener noreferrer">
                Click here&nbsp;
              </a>
              to login to L’Oréal Partner Shop and follow the steps below to complete your online order:
            </div>
            <div className="steps s1">
              <div>1. Click “Basket” in the top right corner</div>
              <img src={step1} alt="Click on basket" />
            </div>
            <div className="steps s2">
              <div>
                2. Scroll down and click “Upload CSV file” <p />
                3. Click “Choose file” and select the <strong>Slick Stock Order</strong> CSV file from your downloads
              </div>
              <img src={step2} alt="Choose file" />
            </div>
            <div className="steps s3">
              <div>
                4. Then click “Upload file” and this will add the products & quantities from your Slick order to your
                LPS basket!
              </div>
              <img src={step3} alt="Upload CSV file" />
            </div>
            <div className="steps s3">
              <br />
              <div>
                Please note L&apos;Oreal Partner Shop will automatically apply any discount codes or promotions you
                qualify for
              </div>
            </div>
          </SimpleDialog>

          {/*
                     PDF start

                     Workaround for issue to hide pdf
                     SEE: https://getslick.atlassian.net/browse/GS-11052
                     */}

          <table id="table" style={{ display: 'none', top: '101vh', left: '101vw' }}>
            <thead>
              <tr>
                <th>EAN / Barcode</th>
                <th>Brand</th>
                <th>Sub brand</th>
                <th>Product Name</th>
                <th>Quantity</th>
              </tr>
            </thead>
            <tbody>
              {this.props.emptyBasket && (
                <>
                  {orderKeys.map((key) => {
                    const orderBrand = this.props.orderItems[key];
                    const subBrandKeys = Object.keys(orderBrand).sort((s1, s2) => s1.localeCompare(s2));
                    return (
                      <>
                        {subBrandKeys.map((subKey) => {
                          const subCategory = orderBrand[subKey];

                          const stockListObj = Object.values(subCategory).map((e) => [...e]);
                          const stockListArr = Object.values(stockListObj);
                          const stockList = [];
                          for (let i = 0; i < stockListArr.length; i += 1) {
                            if (stockListArr[i]) {
                              stockList.push(...stockListArr[i]);
                            }
                          }
                          const items = stockList;
                          return (
                            <>
                              {items.map((product) => (
                                <tr key={product.product}>
                                  <td>{product.barcode}</td>
                                  <td>{key.replace(/’/, "'")}</td>
                                  <td>{product.sub_brand}</td>
                                  <td>{product.title}</td>
                                  <td>{product.quantity}</td>
                                </tr>
                              ))}
                            </>
                          );
                        })}
                      </>
                    );
                  })}
                </>
              )}
            </tbody>
          </table>
          {/* PDF end */}

          {/*
                     EXCEL start

                     Workaround for issue to hide excel tables
                     SEE: https://getslick.atlassian.net/browse/GS-11052
                     */}

          <table id="table-to-excel" style={{ display: 'none', top: '101vh', left: '101vw' }}>
            <thead>
              <tr>
                <th />
                <th />
              </tr>
            </thead>
            <tbody>
              {this.props.emptyBasket && (
                <>
                  {orderKeys.map((key) => {
                    const orderBrand = this.props.orderItems[key];
                    const subBrandKeys = Object.keys(orderBrand).sort((s1, s2) => s1.localeCompare(s2));
                    return (
                      <>
                        {subBrandKeys.map((subKey) => {
                          const subCategory = orderBrand[subKey];

                          const stockListObj = Object.values(subCategory).map((e) => [...e]);
                          const stockListArr = Object.values(stockListObj);
                          const stockList = [];
                          for (let i = 0; i < stockListArr.length; i += 1) {
                            if (stockListArr[i]) {
                              stockList.push(...stockListArr[i]);
                            }
                          }
                          const items = stockList;
                          return (
                            <>
                              {items.map((product) => (
                                <tr key={product.product}>
                                  <td>{product.barcode}</td>
                                  <td>{product.quantity}</td>
                                </tr>
                              ))}
                            </>
                          );
                        })}
                      </>
                    );
                  })}
                </>
              )}
            </tbody>
          </table>
          {/* EXCEL end */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  salonName: selectCurrentSalonName(state),
  isBarkersSalon: selectCurrentSalonIsBarkers(state),
  isLorealSalon: selectCurrentSalonIsLoreal(state),
});

const TableStocksOrderingHoc = connect(mapStateToProps)(TableStocksOrdering);

export default TableStocksOrderingHoc;
